<template>
  <v-container id="home-layout" class="d-flex flex-column p-0" style="min-height: 100vh; max-width: 1200px;">

    <v-app-bar color="var(--standard)" border-b-thin>

      <v-container class="d-flex justify-space-between align-center p-6 flex-wrap" style="max-width: 1200px;">

          <img 
            src="@/assets/images/logo.png" 
            alt="rivia Descontos"
            @click="navigateTo('/home')" 
            style="cursor: pointer; max-width: 150px;" 
            data-test="logo-vcpode"
          />
          <div class="d-flex justify-content-center align-items-center flex-wrap">
            <v-list-item  :title="user.name" style="color: var(--light-text)"/>
            <v-app-bar-nav-icon @click="drawer = !drawer" style="color: var(--light-text)" data-test="menu"/>
          </div>

      </v-container>
      
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" temporary location="right" >
      <v-list density="default" class="h-100 d-flex flex-column justify-content-between pb-2 overflow-y-auto">
        <div>
          <v-list-item
            v-for="(item, index) in menuItems"
            :key="index"
            :prepend-icon="item.icon" 
            :title="item.title" 
            @click="navigateTo(item.route)" 
            :data-test="item.testId" 
          />
        </div>

        <v-list-item prepend-icon="mdi-logout" title="Sair" @click="logout" data-test="menu-logout" style="color: red"/>
      </v-list>
  </v-navigation-drawer>

    <v-main>
      <router-view class="fill-height"></router-view>
    </v-main>

  </v-container>

</template>

<script>
export default {
  name: "VueHeader",

  data() {
    return {
      drawer: false,
      isLogged: false,
      user: {},
      menuItems: require('@/data/menuItems.js').default,
    };
  },

  mounted() {
    setInterval(()=>{
      this.isLogged= localStorage.getItem("user") ? true: false;
      
      if (!this.isLogged) {
        this.$router.push("/");
      }
    }, 1000)

    try {
      const fullName = JSON.parse(localStorage.getItem("user")).user.name.split(' ');
      this.user.name = fullName[0]
      this.user.partner = JSON.parse(localStorage.getItem("user")).user.partner || '';
    } catch (e) {
      this.$router.push("/");
    }
  },

  methods: {

    navigateTo(route) {
      this.$router.push(route);
    },

    logout() {
      const keysToRemove = [
        "api-key",
        "api-id",
        "worker_id",
        "isLoggedIn",
        "hasPublicId",
        "user",
        "order",
        "userLogin",
        "idToken",
        "selectedPlan",
        "dataOrder"
      ];

      keysToRemove.forEach((key) => localStorage.removeItem(key));
      localStorage.removeItem("user");
      this.isLogged = false;
      this.navigateTo("/");
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep(.v-navigation-drawer__scrim){
  position: fixed;
  height: 100vh;
  z-index: 999; 
}
</style>
